import { PlanType } from '@enums/PlanType';
import MapdColumns from './MapdColumns';
import PdpColumns from './PdpColumns';
import MaColumns from './MaColumns';

const Filters = ({
  primaryProviders,
  specialistProviders,
  prescriptions,
  pharmacy,
  onFilterChange,
  planType,
  user,
}) => {
  const columnsToRender = {
    [PlanType.MAPD]: (
      <MapdColumns
        prescriptions={prescriptions}
        primaryProviders={primaryProviders}
        specialistProviders={specialistProviders}
        pharmacy={pharmacy}
        onFilterChange={onFilterChange}
        user={user}
      />
    ),
    [PlanType.PDP]: <PdpColumns prescriptions={prescriptions} onFilterChange={onFilterChange} pharmacy={pharmacy} />,
    [PlanType.MA]: (
      <MaColumns
        primaryProviders={primaryProviders}
        specialistProviders={specialistProviders}
        onFilterChange={onFilterChange}
        user={user}
      />
    ),
  };

  return <>{columnsToRender[planType]}</>;
};

export default Filters;
